export default function Button({ text, onClick }) {
  const buttonClass =
    "bg-secondary hover:bg-secondaryDark text-4xl px-4 py-1 w-[100%] rounded-md shadow-button hover:shadow-buttonHover text-hover-zoom";
  return (
    <button className={buttonClass} onClick={onClick}>
      <div>{text}</div>
    </button>
  );
}
